
var init = require('./init');

module.exports = init([require('./modules/attributes'), require('./modules/style')]);


/** WEBPACK FOOTER **
 ** ./~/snabbdom-to-html/lib/index.js
 **/